var quizQuestions = [
  {
    question: "Motorists must yield the right-of-way to pedestrians crossing:",
    answers: {
      a: "An intersection without signals or traffic signs.",
      b: "Any crosswalk or marked mid-block crossing.",
      c: "Driveways.",
      d: "All of the above."
    },
    description: "Motorists have the responsibility of avoiding collisions with pedestrians, bicyclists, skaters and skateboarders (all of which are considered pedestrians). <strong>Motorists making any turn must stop for pedestrians at driveways and intersections, even when a crosswalk does not exist.</strong>",
    correctAnswer: "d"
  },
  {
    question: "The maximum speed limits on highways in Ohio is:",
    answers: {
      a: "65 mph",
      b: "45 mph",
      c: "55 mph",
      d: "35 mph"
    },
    description: "The maximum speed limits on highways in Ohio is <strong>55 mph.</strong>",
    correctAnswer: "c"
  },
  {
    question: "In the State of Ohio, you can be charged with Operating a Vehicle While Impaired (OVI) while driving under the influence of:",
    answers: {
      a: "Stimulants.",
      b: "Alcohol.",
      c: "Narcotics.",
      d: "All of the above."
    },
    description: "In the state of Ohio, you can be charged with an OVI while driving under the influence of <strong>drugs or alcohol.</strong>",
    correctAnswer: "d"
  },
  {
    question: "When a traffic signal has malfunctioned, you must:",
    answers: {
      a: "Treat the intersection as a four-way stop.",
      b: "Pull off to the side and wait for instructions from law enforcement.",
      c: "Yield the right-of-way and proceed with caution.",
      d: "Proceed with caution."
    },
    description: "When a traffic signal is not working properly, all vehicles must treat the intersection as a <strong>four-way stop</strong> and yield the right-of-way. If a law enforcement officer is directing traffic, then you must follow the officer's instructions.",
    correctAnswer: "a"
  },
  {
    question: "When a traffic signal shows a steady yellow light, the driver should:",
    answers: {
      a: "Speed up through the intersection to miss the eventual red light.",
      b: "Stop if possible.",
      c: "Make a right turn.",
      d: "Both A and B are correct."
    },
    description: "When approaching an intersection with a steady yellow light, <strong>drivers should use caution by slowing down and prepare to stop</strong> since the light will soon turn red.",
    correctAnswer: "b"
  },
  {
    question: "Ohio's safety belt law provides for a _______ fine for drivers and a _______ fine for front-seat passengers found to be unbelted when stopped for another violation.",
    answers: {
      a: "$30 / $20",
      b: "$50 / $100",
      c: "$100 / $50",
      d: "None of the above."
    },
    description: "Ohio's safety belt law provides for a <strong>$30 fine for drivers and a $20 fine for front-seat passengers</strong> found to be unbelted when stopped for another violation.",
    correctAnswer: "a"
  },
  {
    question: "Compliance is necessary with Ohio's Financial Responsibility Law if:",
    answers: {
      a: "Any time you receive a moving traffic violation.",
      b: "When you're convicted of a moving traffic violation that requires a court appearance.",
      c: "When you're involved in a traffic accident that requires the filing of an accident report.",
      d: "All of the above."
    },
    description: "Compliance with Ohio's Financial Responsibility Law is <strong>necessary any time you receive a moving traffic violation, when you're convicted of a moving traffic violation that requires a court appearance, or when you're involved in a traffic accident that requires the filing of an accident report.</strong>",
    correctAnswer: "d"
  },
  {
    question: "When a double solid white line is drawn, this means:",
    answers: {
      a: "You may not change lanes.",
      b: "You are traveling in a no passing zone.",
      c: "You are traveling on an one-way street.",
      d: "You must reduce your speed ahead."
    },
    description: "When a double solid white center line is drawn, it is to separate two lanes of traffic moving in the same direction. <strong>Crossing a double solid line is prohibited.</strong>",
    correctAnswer: "a"
  },
  {
    question: "All drivers stopped by a police officer who have a blood alcohol level (BAC) of .08 or higher, upon arrest, are subject to:",
    answers: {
      a: "Mandatory penalties of time in jail.",
      b: "Court-imposed driver license suspension.",
      c: "Minimum of $375 to maximum of $10,500 fine.",
      d: "All of these penalties."
    },
    description: "A driver stopped by a police officer who has a blood alcohol level of .08 or higher, upon arrest, is subject to <strong>time in jail, court-imposed driver license suspension, and a fine.</strong>",
    correctAnswer: "d"
  },
  {
    question: "You are required to signal before making any turn at least ________ in advance.:",
    answers: {
      a: "200 feet",
      b: "300 feet",
      c: "100 feet",
      d: "750 feet"
    },
    description: "Use your turn signal at least <strong>100 feet</strong> prior to the turn to allow other drivers to adjust their speed if needed.",
    correctAnswer: "c"
  }
];
